import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const shouldTrack = () =>
    typeof window !== 'undefined' && window.location.hostname === 'dev.dermatrial.com';

export default function RouteChangeTracker() {
    const location = useLocation();
    const initializedRef = useRef(false);

    useEffect(() => {
        if (!initializedRef.current && shouldTrack()) {
            const id = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
            if (id) {
                ReactGA.initialize(id);
                initializedRef.current = true;
            } else {
                console.warn('GA4 ID가 없습니다. .env 확인');
            }
        }
    }, []);

    // 라우트 변경 시 page_view 전송
    useEffect(() => {
        if (!initializedRef.current || !shouldTrack()) return;
        ReactGA.set({ page: location.pathname + location.search, title: document.title });
        ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }, [location]);

    return null;
}
